import { call, put } from 'redux-saga/effects';
import EnhancedProductService from 'services/enhancedProductService';
import { loadOrdersFail } from '../order/actions';
import { loadEnhancedProductsSuccess } from './actions';

export function* loadEnhancedProductsSaga(action: any) {
  try {
    const { data, total } = yield call(
      EnhancedProductService.getEnhancedProducts,
      action.payload.query,
    );
    yield put(
      loadEnhancedProductsSuccess({
        data,
        total,
      }),
    );
  } catch (err) {
    yield put(loadOrdersFail());
  }
}

export function* loadEnhancedProductsOpenEndpointSaga(action: any) {
  try {
    const data = yield call(
      EnhancedProductService.getEnhancedProductsOpenEndpoint,
      action.payload.query,
    );
    yield put(
      loadEnhancedProductsSuccess({
        data,
        total: 0,
      }),
    );
  } catch (err) {
    yield put(loadOrdersFail());
  }
}
